module.exports = __webpack_public_path__ + "img/bucket-fill.7cd6b44d.svg";